<img *ngIf="data.mediaContentType.indexOf('image') !== -1" [src]="data.mediaUrl" width="100%" height="auto" alt="" />
<video
  *ngIf="data.mediaContentType.indexOf('video') !== -1"
  width="100%"
  height="auto"
  controls="controls"
  preload="metadata"
>
  <source [src]="data.mediaUrl" [type]="data.mediaContentType" />
</video>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>
    {{ 'INBOX.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
